import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    wrapper: `
      md:max-w-96
      h-24
      w-full
      lg:w-96
    `,
    content: 'pl-4',
    image: `
      flex
      h-16
      w-16
      items-center
      justify-center
      rounded
      border
      border-gray-200
    `,
  },
});
